import React, { useEffect, useContext, useRef } from 'react'
import { SliderType } from '../utilities/enums'
import { NextpageContext } from '../context/nextpage.context'

export type ISliderProps = {
  sliderType: SliderType
  labelList: any[]
  slideList: any[]
  captionList: any[]
}

const Slider = ({
  sliderType,
  labelList,
  slideList,
  captionList
}: ISliderProps) => {
  const nextpage = useContext(NextpageContext)
  const sliderRef = useRef(null)

  useEffect(() => {
    nextpage.UI.components.slider(sliderRef.current)
  })

  let isGallery = sliderType === SliderType.Gallery
  const labels = labelList.map((ll, i) => (
    <li key={i} className={`${i === 0 ? 'aria-selected' : ''}`}>
      {ll}
    </li>
  ))
  const slides = slideList.map((sl, i) => (
    <div key={i} className={`slide ${i === 0 ? 'aria-selected' : ''}`}>
      {sl}
    </div>
  ))
  const captions = captionList.map((cl, i) => (
    <div key={i} className={`caption ${i === 0 ? 'aria-selected' : ''}`}>
      {cl}
    </div>
  ))
  return (
    <React.Fragment>
      <div ref={sliderRef} className={`slider ${isGallery ? 'gallery' : ''}`}>
        {!isGallery && <ul className={`labels`}>{labels}</ul>}
        <div>{slides}</div>
        {isGallery && <div className={`caption-wrapper`}>{captions}</div>}
      </div>
    </React.Fragment>
  )
}

export default Slider